import { useNavigate } from 'react-router-dom';
import { Radar } from 'lucide-react';

import { ConsoleLayout } from '@/components/layout/ConsoleLayout';
import { PLATFORM_NAV } from '@/constants/navigation';
import { useAuthStore } from '@/features/auth/store/auth.store';

/**
 * The platform console — our own staff, looking across every institute.
 *
 * Every console shares one frame (`ConsoleLayout`) and now one palette with it:
 * the same indigo rail and the same tinted banners the teacher and parent
 * panels are drawn in. It used to ask for a near-black skin of its own, which
 * read as a different product from the one it administers. What tells the tabs
 * apart is the mark, the title and the menu — not a second colour scheme.
 */
export function PlatformLayout() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  return (
    <ConsoleLayout
      nav={PLATFORM_NAV}
      brand={{
        // A sweep rather than a building: this console is the one that looks
        // across all of them, and the buildings belong to the customers.
        mark: <Radar className="h-[17px] w-[17px]" strokeWidth={2} />,
        title: 'Platform console',
        subtitle: 'Every institute, at once',
      }}
      account={{ name: user?.fullName ?? '', meta: user?.email ?? '' }}
      onSignOut={async () => {
        await logout();
        navigate('/login', { replace: true });
      }}
      greeting={
        <span className="hidden items-center gap-2 lg:inline-flex">
          <span className="relative grid h-2 w-2 place-items-center" aria-hidden>
            <span className="absolute inset-0 animate-glow rounded-full bg-accent" />
            <span className="h-1 w-1 rounded-full bg-accent" />
          </span>
          <span className="text-sm font-medium text-ink-2">
            Platform staff — institute data is reached only through an audited action.
          </span>
        </span>
      }
    />
  );
}
